.image {
    max-width: 100%;
    height: auto;
    display: block;
}
